var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickSmall = function SvgTickSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70549 13.1255C5.31586 12.7359 5.31586 12.1041 5.70549 11.7145C6.09474 11.3253 6.7257 11.3248 7.11549 11.7135L10 14.59L16.8804 7.70961C17.2719 7.31811 17.9074 7.31963 18.2975 7.71251C18.6857 8.10343 18.6849 8.73506 18.2954 9.12461L10.7071 16.7129C10.3166 17.1034 9.68342 17.1034 9.29289 16.7129L5.70549 13.1255Z"
  })));
};
export default SvgTickSmall;